"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_virtuoso_1 = require("react-virtuoso");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var CircularProgress_1 = require("../../../atoms/CircularProgress/CircularProgress");
var Typography_1 = require("../../../atoms/Typography/Typography");
var ListBox_logic_1 = require("./ListBox.logic");
var ListBox_static_1 = require("./ListBox.static");
var ListBox = function (_a, ref) {
    var children = _a.children, helperText = _a.helperText, _b = _a.noOptions, noOptions = _b === void 0 ? false : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.noOptionsText, noOptionsText = _d === void 0 ? ListBox_static_1.localText.noOptions : _d, fetchMore = _a.fetchMore, renderItem = _a.renderItem, groupedItems = _a.groupedItems, items = _a.items, groupBy = _a.groupBy, virtuosoRef = _a.virtuosoRef, loadingElement = _a.loadingElement, popperRef = _a.popperRef, ulProps = __rest(_a, ["children", "helperText", "noOptions", "loading", "noOptionsText", "fetchMore", "renderItem", "groupedItems", "items", "groupBy", "virtuosoRef", "loadingElement", "popperRef"]);
    var _e = (0, ListBox_logic_1.useListBox)({
        fetchMore: fetchMore,
        groupedItems: groupedItems,
        helperText: helperText,
        items: items,
        loading: loading,
        noOptions: noOptions,
        noOptionsText: noOptionsText,
        popperRef: popperRef,
    }), classes = _e.classes, getGroupKey = _e.getGroupKey, getGroupedItem = _e.getGroupedItem, groupCounts = _e.groupCounts, handleEndReached = _e.handleEndReached, handleHeightChange = _e.handleHeightChange, headerText = _e.headerText, virtuosoStyle = _e.virtuosoStyle;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: ref }, ulProps, { className: classes.root }, { children: [renderHeaderText(), groupBy ? renderGroupedList() : renderList()] })));
    function renderList() {
        return ((0, jsx_runtime_1.jsx)(react_virtuoso_1.Virtuoso, { ref: virtuosoRef, data: items, itemContent: function (index, option) { return renderItem(option, index); }, style: virtuosoStyle, overscan: 4, increaseViewportBy: 2, totalListHeightChanged: handleHeightChange, endReached: handleEndReached, components: {
                Footer: renderFetchMore,
            } }));
    }
    function renderGroupedList() {
        return ((0, jsx_runtime_1.jsx)(react_virtuoso_1.GroupedVirtuoso, { ref: virtuosoRef, style: virtuosoStyle, groupCounts: groupCounts, overscan: 4, increaseViewportBy: 2, totalListHeightChanged: handleHeightChange, endReached: handleEndReached, groupContent: function (index) { return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: classes.groupLabel, variant: 'headline2', color: theme_1.default.textColors.primaryLight, noWrap: true }, { children: getGroupKey(index) }))); }, itemContent: function (itemIndex, groupIndex) {
                var _a = getGroupedItem(itemIndex), option = _a.option, index = _a.index;
                return renderItem(option, index, getGroupKey(groupIndex));
            }, components: {
                Footer: renderFetchMore,
            } }));
    }
    function renderHeaderText() {
        if (!headerText) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'label1', className: classes.headerText, color: theme_1.default.textColors.primaryLight }, { children: headerText })));
    }
    function renderFetchMore() {
        if (!fetchMore) {
            return null;
        }
        if (loadingElement) {
            return loadingElement;
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.fetchMore }, { children: [(0, jsx_runtime_1.jsx)(CircularProgress_1.CircularProgress, { size: 18, color: theme_1.default.colors.primary }), (0, jsx_runtime_1.jsx)(Typography_1.Typography, { children: ListBox_static_1.localText.loading })] })));
    }
};
exports.default = (0, react_1.forwardRef)(ListBox);
